export default __webpack_public_path__ + "static/media/about.26776041.png";